
import { getTagType } from '@/utils';
import { Wrapper } from './styles';

export default {
  name: 'Tag',
  components: {
    Wrapper,
  },
  props: {
    dot: {
      type: Boolean,
      default: true,
    },
    title: String,
  },
  methods: {
    renderTag(value: string) {
      return getTagType(value);
    },
  },
};
